import type { QueryFunctionContext, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { extensionSettingsQueryKeys } from "../key-factory/factory";

export const useExtensionVersionQuery = (): UseQueryResult<string> => {
    return useQuery({
        queryKey: extensionSettingsQueryKeys.extensionVersion(),
        queryFn({ signal }: QueryFunctionContext): Promise<string> {
            return salesApiService.extensionManagement.fetchExtensionVersion({ cancellation: signal });
        },
    });
};
